// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_DOWNLOAD_APP_PROMO_LABELS = 'global.DownloadAppPromo';

export const lblDownloadAppPromoTitle = `lbl_title`;
export const lblDownloadAppPromoSubTitle = `lbl_subTitle`;
export const lblDownloadAppPromoCTA = `lbl_download_cta`;

export const DownloadAppPromoLabels = {
  global: {
    DownloadAppPromo: {
      [lblDownloadAppPromoTitle]: '4 BRANDS, 1 PLACE',
      [lblDownloadAppPromoSubTitle]:
        'Download the NEW enhanced app & get instant access to head-to-toe styles!',
      [lblDownloadAppPromoCTA]: 'Download the App',
    },
  },
};
